<template lang="pug">
  validation-observer(ref="form")
    form(@submit.prevent="onSubmit" :class="b()")
      validation-provider(name="monto" rules="required|min_value:828116|max_value:160000000" v-slot="{ errors }")
        label Total de todos tus ingresos mensuales
        v-text-field-money(
          v-model="data.amount"
          :error-messages="errors"
          name="monto"
        )
      slot
</template>

<script>
  import formMixin from '@/mixins/form-mixin';

  const DEFAULT_VALUES = {
    amount: null,
  };

  export default {
    name: 'incomes-form',

    mixins: [
      formMixin(),
    ],

    props: {
      lastAnswer: { type: [Object, Array], required: true },
    },

    data() {
      return {
        data: {
          ...DEFAULT_VALUES,
          categoryId: Array.isArray(this.lastAnswer) ?
            this.lastAnswer[0].value :
            this.lastAnswer.value,
        },
      };
    },
  };
</script>

<style lang="sass" scoped>
  .customer-form
    &__error
      color: red
      font-size: 0.9rem

    .label
      font-size: 0.85rem
      margin: 0
</style>